import { InjectionToken } from '@angular/core';

export const MAXBRAIN_ERROR_URL_EXCEPTIONS = new InjectionToken<RegExp[]>('MAXBRAIN_ERROR_URL_EXCEPTIONS');
